module.exports = __webpack_public_path__ + "img/refer-your-friends.51f38aa.png";